module.exports = __webpack_public_path__ + "static/media/settings_active.38500213.svg";